import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { object, array, bool, string } from "prop-types";

import { getExcerpt } from "../../../utils/utils";

import CardImage from "../../../atoms/CardImage";
import NewsHeadline from "../../../atoms/NewsHeadline";
import LiveNewsHeadline from "../../../atoms/liveNewsHeadline";
import Excerpt from "../../../atoms/Excerpt";
import SectionHolder from "../../../atoms/SectionHolder";
import SponsorDetails from "../../../molecules/SponsorDetails";

import "./organism1.m.css";

const Organism1 = ({
  story,
  showHeroImage = true,
  aspectRatio = [3, 2],
  imageType = "image3x2",
  widths = [250, 480, 764],
}) => {
  const excerpt = getExcerpt(story);
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  const showLiveBlog = story["story-template"] === "live-blog";

  const imageCaption = () => {
    if (get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"])) {
      return get(story, ["alternative", "home", "default", "hero-image", "hero-image-caption"]);
    } else if (
      !get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) &&
      get(story, ["hero-image-caption"])
    ) {
      return get(story, ["hero-image-caption"]);
    } else return null;
  };

  const imageAttribute = () => {
    if (get(story, ["alternative", "home", "default", "hero-image", "hero-image-attribution"])) {
      return get(story, ["alternative", "home", "default", "hero-image", "hero-image-attribution"]);
    } else if (
      !get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) &&
      get(story, ["hero-image-attribution"])
    ) {
      return get(story, ["hero-image-attribution"]);
    } else return null;
  };

  let heroImage = "";

  if (get(story, ["alternative", "home", "default", "hero-image"])) {
    heroImage = story.alternative.home.default["hero-image"]["hero-image-s3-key"]
      ? story.alternative.home.default["hero-image"]["hero-image-s3-key"]
      : story.alternative.home.default["hero-image"].key
      ? story.alternative.home.default["hero-image"].key
      : "";
  } else if (story["hero-image-s3-key"]) {
    heroImage = story["hero-image-s3-key"];
  }
  return (
    <div styleName={`news_item lead_story ${heroImage ? "" : "no-image"}`}>
      <div styleName="photo">
        {showHeroImage && (
          <Link aria-label={story.headline} href={story.url}>
            <CardImage
              story={story}
              aspectRatio={aspectRatio}
              imageType={imageType}
              widths={widths}
              showAlternateImage={true}
            />
          </Link>
        )}
        <div styleName="caption">
          {imageCaption() && <span>{imageCaption()}</span>}
          {imageCaption() && imageAttribute() && <span> | </span>}
          {imageAttribute() && <span>{imageAttribute()}</span>}
        </div>
      </div>
      <div styleName="text">
        {showLiveBlog ? (
          <LiveNewsHeadline story={story} cssStyleName="bigSize" Htag="h1" />
        ) : (
          <NewsHeadline cssStyleName="bigSize" story={story} Htag="h1" />
        )}
        <Excerpt excerpt={excerpt} excerptLink={story.url} />
        {sponsorId && !showLiveBlog ? (
          <SponsorDetails sponsorId={sponsorId} showImage={false} />
        ) : (
          <SectionHolder story={story} />
        )}
      </div>
    </div>
  );
};

Organism1.propTypes = {
  story: object.isRequired,
  showHeroImage: bool,
  aspectRatio: array,
  imageType: string,
  widths: array,
};

export default Organism1;
